import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Banner from "../../../component/Banner";
import Bannerimg from "../../../images/manufacturing/manufacturing-banner.webp";
import image1 from "../../../images/manufacturing/manufacturing1.webp";
import image2 from "../../../images/manufacturing/manufacturing2.webp";
import image3 from "../../../images/manufacturing/manufacturing3.webp";
import image4 from "../../../images/manufacturing/manufacturing4.webp";

const Manufacturing = () => {
  const banner = {
    title: "Manufacturing",
    image: Bannerimg,
  };
  const card = [
    {
      image: image1,
      title: "Automotive",
      description:
        "Automotive manufacturers and their partners are facing key challenges in the face of technological and competitive factors playing a crucial role in the manufacturing of innovative products in the automobile industry. The ever changing consumer preferences, tightening regulations driven by new trends are also encouraging new players to enter the automotive market with innovative products and services. In addition, to enhance the driving experience for all end users or customers, the automotive industry is embracing the disruptively changing technology in the market.",
      tagName: "Learn More",
      tagLink: "automotive",
    },
    {
      image: image2,
      title: "Industrial",
      description: `Cylon Technologies manufacturing industry solutions are helping a multitude of manufacturers across the globe in building their future ready business processes by leveraging our unique industrial manufacturing solutions model. <br/>Manufacturing operations are generating huge data as any other industry segment and therefore companies that adopt digital technology are poised to thrive in the present competitive manufacturing environment. `,
      tagName: "Learn More",
      tagLink: "industrial",
    },
    {
      image: image3,
      title: "Mining and Metal",
      description: `Mining and metal companies are required to address the challenges of optimizing their processes and operations along with keeping up their equipment operational while also ensuring the safety of their staff. In addition, these companies face numerous issues in the form of diminishing margins, shortage of power and raw materials, escalating energy, transportation, labor and equipment costs.   <br/>In the face of environmental concerns pertaining to global warming, carbon trading, and anti-pollution legislation - the need for better asset management and cost control cannot be underestimated and as such to manage these concerns you need an integrated view of your entire mining and metal production and operations.`,
      tagName: "Learn More",
      tagLink: "metalandmining",
    },
    {
      image: image4,
      title: "Process",
      description: `Process manufacturers are required to ensure manufacturing consistency throughout the production cycle with intensive, multifaceted shop floor execution capabilities and as such this sector is heavily investing in Internet of Things and in other digital technologies. This digital transformation is helping them in optimizing their supply chain operations, in driving down the operating costs and an increase in their plant yield. <br/>Leading manufacturers are improving their business operations by collaborating with Cylon Technologies in their digital transformational journey of achieving operational excellence and superior customer experience along the value chain. Cylon Technologies combines its industry leading practices with processes with its deep domain expertise in shop floor operations thereby helping process manufacturing companies in effectively tackling with their key challenges.`,
      tagName: "Learn More",
      tagLink: "processmanufacturing",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Manufacturing — Cylon Technologies – Big Data | Data Analytics |
          Digital Strategy
        </title>
      </Helmet>
      <Banner heading={banner.title} bannerimg={banner.image} />
      <section className="sec-padd page_content pb-5">
        <div className="container">
          <h2 className="heading2 text-center pb-4">Manufacturing Solutions</h2>
          <p>
            Process manufacturers are required to ensure manufacturing
            consistency throughout the production cycle with intensive,
            multifaceted shop floor execution capabilities and as such this
            sector is heavily investing in Internet of Things and in other
            digital technologies. This digital transformation is helping them in
            optimizing their supply chain operations, in driving down the
            operating costs and an increase in their plant yield.
          </p>
          <p>
            Leading manufacturers are improving their business operations by
            collaborating with Cylon Technologies in their digital
            transformational journey of achieving operational excellence and
            superior customer experience along the value chain. Cylon
            Technologies combines its industry leading practices with processes
            with its deep domain expertise in shop floor operations thereby
            helping process manufacturing companies in effectively tackling with
            their key challenges.
          </p>
          <p>
            Our decade long experience of partnering with manufacturing
            organizations has helped them in achieving operational efficiency
            and financial stability in their materials and manufacturing
            processes. We offer a comprehensive suite of process manufacturing
            solution, business analytics capabilities and ERP deployment skills
            resulting in organizations creating smart and efficient production
            environment.
          </p>
          <div className="col-md-10 mx-auto">
            <div className="row g-md-5 g-4">
              {card.map((item, index) => (
                <div className="col-md-6" key={index}>
                  <div className="img_card">
                    <img src={item.image} alt="images" />
                    <h2 className="heading2">{item.title}</h2>
                    <p
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    ></p>

                    {item.tagName && item.tagLink && (
                      <div className="btn_spacet">
                        <a
                          href={item.tagLink}
                          className="btn_small outline_blue"
                        >
                          {item.tagName}
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="text-center pt-5 mt-5">
              <Link
                to="/connect"
                className="btn_custom blue_btn"
                href="Inquire"
              >
                Inquire
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Manufacturing;
